import {
  trigger,
  transition,
  style,
  query,
  group,
  animate,
  AnimationMetadata
} from '@angular/animations';

/**
 * Returns reusable slide animation steps for a given direction.
 * @param direction 'left' or 'right'
 */
function slideAnimation(direction: 'left' | 'right'): AnimationMetadata[] {
  const enterFrom = direction === 'left' ? '-100%' : '100%';
  const leaveTo = direction === 'left' ? '100%' : '-100%';

  return [
    style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        [direction]: 0,
        width: '100%',
      })
    ], { optional: true }),
    query(':enter', [
      style({ [direction]: enterFrom })
    ], { optional: true }),
    group([
      query(':leave', [
        animate('600ms ease', style({ [direction]: leaveTo }))
      ], { optional: true }),
      query(':enter', [
        animate('600ms ease', style({ [direction]: '0%' }))
      ], { optional: true }),
    ])
  ];
}

export const slider = trigger('routeAnimations', [
  // Generic directional transitions
  transition('* => isLeft', slideAnimation('left')),
  transition('isRight => *', slideAnimation('left')),
  transition('plan => customer', slideAnimation('left')),
  transition('payment => plan', slideAnimation('left')),
  transition('customer => vehicle', slideAnimation('left')),

  transition('* => isRight', slideAnimation('right')),
  transition('isLeft => *', slideAnimation('right')),
  transition('customer => plan', slideAnimation('right')),
  transition('vehicle => customer', slideAnimation('right')),
  transition('plan => payment', slideAnimation('right')),
  transition('payment => download', slideAnimation('right')),
]);
